module.exports = "/fonts/vendor/quasar-extras/material-icons/web-flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.woff2?8a9a261c8b8dfe90db11f1817a9d22e1";


//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/material-icons/web-font/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.woff2
// module id = 9Niu
// module chunks = 49